import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MaterialFormSettingsModel } from '../../../core/models/material/material-form-settings.model';
import { TextKeys } from '../../../core/i18n/text-keys';
import { MaterialFormComponent } from '../materail-form/material-form.component';
import { ToastService } from '../../../core/services/toast-service';
import { TranslateService } from '@ngx-translate/core';
import { SessionQuery } from '../../../core/state-mangement/session/session.query';
import { MaterialItemsService } from '../../../core/state-mangement/entities/material-items/material-items.service';
import { WorkInfoQuery } from '../../../core/state-mangement/work-info/work-info.query';
import { MaterialCatalogueItemsQuery } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.query';
import { MaterialCatalogueItemsService } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.service';
import { Subscription } from 'rxjs';
import { TimeEntriesQuery } from '../../../core/state-mangement/entities/time-entries/time-entries.query';
import { LocalStateKeys } from '../../../core/state-mangement/local-state-keys';
import { WorkInfoStoreService } from '../../../core/state-mangement/work-info-store-service';
import { MaterialModel } from '../../../core/models/material/material-model';
import { PersonalApiModel } from '../../../core/models/personal/person-api.model';
import { OrderModel } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-material-widget',
  templateUrl: './material-widget.component.html',
  styleUrls: ['./material-widget.component.scss'],
})
export class MaterialWidgetComponent implements OnInit, OnDestroy {
  @ViewChild('formElement') formElement: MaterialFormComponent;

  @Input() setTimeEntry: boolean;
  @Input() linkTimeEntry = true;
  @Input() cacheMaterialForTimeEntryID: boolean;
  @Input() workInfoKey: LocalStateKeys;

  formSettings = {
    name: true,
    quantity: true,
    price: true,
    nameAsCatalogueSelection: true,
  } as MaterialFormSettingsModel;
  texts = TextKeys;

  private subscriptions = new Subscription();
  private workInfoQuery: WorkInfoQuery;

  constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
    private sessionQuery: SessionQuery,
    private materialItemsService: MaterialItemsService,
    private timeEntriesQuery: TimeEntriesQuery,
    private materialCatalogueItemsQuery: MaterialCatalogueItemsQuery,
    private workInfoStoreService: WorkInfoStoreService,
    private materialCatalogueItemsService: MaterialCatalogueItemsService
  ) {}

  ngOnInit() {
    this.workInfoQuery = this.workInfoStoreService.getOrCreateStore(
      this.workInfoKey
    ).query;

    this.subscriptions.add(
      this.materialCatalogueItemsQuery.selectActive().subscribe((material) => {
        if (material && this.formElement) {
          this.formElement.Quantity.setValue(material?.quantity);
          this.formElement.Name.setValue(material?.name);
          this.formElement.Price.setValue(material?.price);
        } else {
          if (this.formElement) {
            this.formElement.Price.reset();
            this.formElement.Name.setValue('');
            this.formElement.Quantity.reset();
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onSave() {
    this.formElement.markAllTouched();
    if (!this.formElement.allRequiredFiled()) {
      this.toastService.presentErrorToast({
        message: this.translateService.instant(TextKeys.timeEntryForm.allFields)
      });
      return;
    }

    const selected = this.materialCatalogueItemsQuery.getActive();

    const newMaterial = {
      description: this.formElement.Name.value,
      quantity: this.formElement.Quantity.value,
      price: this.formElement.Price.value,
      description2: selected?.description,
      unit: selected?.unit,
      number: selected?.number,
      date: new Date(),
      person: {
        id: this.sessionQuery.getValue()?.user?.id,
      } as PersonalApiModel,
      order: {
        id: this.workInfoQuery.getValue()?.workInfo?.order?.order?.orderID,
      } as OrderModel,
    } as MaterialModel;

    if (!newMaterial.order.id || newMaterial.order.id === 0) {
      this.toastService.presentInfoToast({
        message: this.translateService.instant(TextKeys.general.selectOrderFirst)
      });
      return;
    }
    if (this.setTimeEntry) {
      newMaterial.timeEntryID = this.timeEntriesQuery.getActive()?.timeEntryID;
    }
    newMaterial.linkTimeEntry = this.linkTimeEntry;

    this.materialItemsService.saveNewMaterial(newMaterial).subscribe(
      (data) => {
        if (this.cacheMaterialForTimeEntryID) {
          newMaterial.id = data.resultObject.id;
        }
        this.formElement.clearForm();
        this.toastService.presentInfoToast({ message: data.message });
      },
      (error) => {
        this.formElement.clearForm();
        if (error.error?.message) {
          this.toastService.presentErrorToast({ message: error.error.message });
        }
      }
    );

    this.materialCatalogueItemsService.clearCache();
  }
}
